export default {
    "Rename": "Renommer",
    "Delete": "Supprimer",
    "This project has been disabled": "Ce projet a été désactivé"
}